import polylabel from "polylabel"
import { point, lineString } from "@turf/helpers"
import area from "@turf/area"
import length from "@turf/length"
import { formatArea, formatLength } from "./DrawingToolFunctions"
import distance from "@turf/distance"
import { destination } from "@turf/turf"


export class ExtendWithMeasureMents {
  static enable(modes: { [key: string]: object }) {
    Object.keys(modes).forEach((key) => {
      modes[key] = extendWithMeasureMents(modes[key])
    });
    return modes;
  }
}

function extendWithMeasureMents(obj) {
  return {
    ...obj,
    toDisplayFeatures: function (a, b, c) {
      if (!a && !b && !c) {
        return;
      }
      let feature = this._ctx.api.get(b.properties.id)
      addMeasurements.apply(this, [a, b, c, feature])
      if (Object.keys(a).length == 0) {
        c(feature)
      }
      return obj.toDisplayFeatures?.apply?.(this, [a, b, c])
    }
  }
}

const addMeasurements = (state: any, geojson: any, push: any, feature: any) => {
  if (feature.properties.circleRadius && geojson.geometry.coordinates?.[0].length > 1) {
    let center = geojson.geometry.coordinates[0][0]
    let line = lineString([center, destination(center, feature.properties.circleRadius, 90).geometry.coordinates], {
      ...geojson.properties,
      "meta": "measure",
      "meta:type": "LineString",
      "length": formatLength(feature.properties.circleRadius),
    })
    push(line)
    push(lineString([center, destination(center, feature.properties.circleRadius, 90).geometry.coordinates], {
      ...geojson.properties,
    }))
    return
  }
  if (geojson.geometry.type === "LineString" || geojson.geometry.type === "Polygon") {
    let coordinates = geojson.geometry.type === "LineString" ? geojson.geometry.coordinates : geojson.geometry.coordinates[0];
    if (coordinates.length < 2) {
      return;
    }
    coordinates.forEach((element, idx) => {
      let prevIdx = idx - 1;
      if (prevIdx < 0 && !(geojson.geometry.type === "Polygon")) {
        return;
      }
      push(lineString([coordinates.at(prevIdx), element], {
        ...geojson.properties,
        "meta": "measure",
        "length": formatLength(length(lineString([coordinates.at(prevIdx), element]) as any)),
      }))

    });
    if (geojson.geometry.type === "Polygon") {
      push(point(polylabel(geojson.geometry.coordinates, 0.001), {
        ...geojson.properties,
        "meta": "measure",
        "meta:type": "Point",
        "length": formatLength(length(geojson as any)),
        "area": formatArea(area(geojson as any)),
      }))
    }
    if (geojson.geometry.type === "LineString") {
      push(point(geojson.geometry.coordinates.at(-1), {
        ...geojson.properties,
        "meta": "measure",
        "meta:type": "Point",
        "length": formatLength(length(geojson as any)),
      }))
    }
  }
  return;
}